import React, { useState } from "react";
import { WetLabItems } from "./NavItems";
import { Link } from "react-router-dom";
import "./Dropdown.css";
import GoToTop from "./GoToTop";

function DropdownW() {
  const [dropdownW, setDropdownW] = useState(false);

  return (
    <>
      <ul
        className={dropdownW ? "submenu clicked" : "submenu"}
        onClick={() => setDropdownW(!dropdownW)}
      >
        {WetLabItems.map((item) => {
          return (
            <li key={item.id}>
              <Link 
                to={item.path}
                className={item.cName}
                onClick={() => {setDropdownW(false);GoToTop();}}
              >
                {item.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropdownW;
